// TODO remove this as it didn't need to exist, we already had cookie helpers in utils/helpers/cookie
export function getCookie(id) {
  return document.cookie.split(';').reduce((acc, entry = '') => {
    if (!acc && entry.replace(/\s/g, '').indexOf(`${id}=`) === 0) {
      const pair = entry.split('=');
      return pair[1];
    }
    return acc;
  }, '');
}

export default getCookie;
